(function () {
  'use strict';
  var $ = function (s, r) { return (r || document).querySelector(s); };
  var $$ = function (s, r) { return Array.prototype.slice.call((r || document).querySelectorAll(s)); };
  function safe(fn) { try { fn(); } catch (e) { if (window.console) console.error('[bk]', e); } }

  /* Gallery videos: play when their slide is active and the gallery is visible; click toggles sound and controls */
  safe(function () {
    var vids = $$('video[data-gallery-video]');
    if (!vids.length) return;
    var visible = true;
    function sync() {
      vids.forEach(function (v) {
        var slide = v.closest('[data-slide]');
        var active = !slide || slide.classList.contains('is-active');
        if (active && visible) {
          if (v.preload !== 'auto') { v.preload = 'auto'; }
          var p = v.play(); if (p && p.catch) p.catch(function () {});
        } else if (!v.paused) { v.pause(); }
      });
    }
    var gallery = vids[0].closest('[data-gallery]') || vids[0].parentNode;
    if ('IntersectionObserver' in window) {
      new IntersectionObserver(function (en) { visible = en[0].isIntersecting; sync(); }, { threshold: 0.35 }).observe(gallery);
    }
    if ('MutationObserver' in window) {
      vids.forEach(function (v) {
        var slide = v.closest('[data-slide]');
        if (slide) new MutationObserver(sync).observe(slide, { attributes: true, attributeFilter: ['class'] });
      });
    }
    vids.forEach(function (v) {
      v.addEventListener('loadeddata', sync);
      var btn = v.parentNode.querySelector('[data-vplay]');
      function enable(e) {
        if (e) { e.preventDefault(); e.stopPropagation(); }
        v.muted = false; v.controls = true; v.loop = false;
        var p = v.play(); if (p && p.catch) p.catch(function () {});
        if (btn) btn.hidden = true;
      }
      if (btn) btn.addEventListener('click', enable);
      v.addEventListener('click', function (e) { if (!v.controls) enable(e); });
    });
    setTimeout(sync, 300);
  });

  /* Step videos and other autoplay videos: play in view (repeat of bk.js logic, independent of it) */
  safe(function () {
    if (!('IntersectionObserver' in window)) return;
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) {
        var v = en.target;
        if (en.isIntersecting) { v.muted = true; var p = v.play(); if (p && p.catch) p.catch(function () {}); } else { v.pause(); }
      });
    }, { threshold: 0.3 });
    $$('video[data-autoplay]').forEach(function (v) { io.observe(v); });
  });

  /* Video lightbox for review videos */
  safe(function () {
    var btns = $$('[data-video-url]');
    if (!btns.length) return;
    var box = document.createElement('div');
    box.className = 'bk-vbox'; box.hidden = true;
    box.setAttribute('role', 'dialog'); box.setAttribute('aria-modal', 'true'); box.setAttribute('aria-label', 'Video');
    box.innerHTML = '<div class="bk-vbox__inner"><button type="button" class="bk-vbox__close" aria-label="Schließen">×</button><video controls playsinline></video></div>';
    document.body.appendChild(box);
    var vid = $('video', box);
    function close() { vid.pause(); vid.removeAttribute('src'); vid.load(); box.hidden = true; document.documentElement.style.overflow = ''; }
    $('.bk-vbox__close', box).addEventListener('click', close);
    box.addEventListener('click', function (e) { if (e.target === box) close(); });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && !box.hidden) close(); });
    btns.forEach(function (b) {
      b.addEventListener('click', function (e) {
        e.preventDefault();
        vid.src = b.getAttribute('data-video-url');
        box.hidden = false; document.documentElement.style.overflow = 'hidden';
        var p = vid.play(); if (p && p.catch) p.catch(function () {});
        $('.bk-vbox__close', box).focus();
      });
    });
  });

  /* Forms: send without page reload and show a readable success card */
  safe(function () {
    $$('form[data-ajax-form]').forEach(function (form) {
      form.addEventListener('submit', function (e) {
        if (form.dataset.native === '1') return;
        e.preventDefault();
        var btn = form.querySelector('[type="submit"]');
        var label = btn ? btn.textContent : '';
        if (btn) { btn.disabled = true; btn.textContent = 'Wird gesendet …'; }
        function native() { form.dataset.native = '1'; HTMLFormElement.prototype.submit.call(form); }
        fetch(form.action, { method: 'POST', body: new FormData(form), credentials: 'same-origin', headers: { Accept: 'text/html' } })
          .then(function (res) {
            var url = res.url || '';
            if (res.ok && url.indexOf('/challenge') === -1 && (url.indexOf('contact_posted=true') !== -1 || res.redirected)) {
              var tpl = form.querySelector('template[data-form-ok]');
              var holder = document.createElement('div');
              holder.innerHTML = tpl ? tpl.innerHTML : '<div class="bk-formok" role="status" tabindex="-1"><strong class="bk-formok__title">Danke!</strong><p class="bk-formok__text">Deine Nachricht ist angekommen.</p></div>';
              var title = form.querySelector('strong');
              form.innerHTML = '';
              if (title) form.appendChild(title);
              form.appendChild(holder.firstElementChild || holder);
              var ok = form.querySelector('.bk-formok'); if (ok) ok.focus();
              form.scrollIntoView({ behavior: 'smooth', block: 'center' });
            } else { native(); }
          })
          .catch(function () { if (btn) { btn.disabled = false; btn.textContent = label; } native(); });
      });
    });
    var posted = $('.bk-formok');
    if (posted && location.search.indexOf('contact_posted=true') !== -1) {
      setTimeout(function () { posted.scrollIntoView({ block: 'center' }); posted.focus(); }, 150);
    }
  });

  /* Fallback: if a muted autoplay video is still paused (e.g. iOS Low Power Mode), show a tap-to-play button */
  safe(function () {
    $$('video[data-autoplay], video[data-gallery-video]').forEach(function (v) {
      v.muted = true; v.defaultMuted = true;
      var tap = v.parentNode.querySelector('[data-vtap]');
      function tryPlay() { var p = v.play(); if (p && p.catch) p.catch(function () { if (tap) tap.hidden = false; }); }
      if (tap) tap.addEventListener('click', function (e) { e.preventDefault(); tap.hidden = true; v.controls = false; tryPlay(); });
      v.addEventListener('playing', function () { if (tap) tap.hidden = true; });
      setTimeout(function () {
        var r = v.getBoundingClientRect();
        var inView = r.bottom > 0 && r.top < window.innerHeight && r.width > 0;
        var slide = v.closest('[data-slide]');
        var active = !slide || slide.classList.contains('is-active');
        if (inView && active && v.paused) { tryPlay(); setTimeout(function () { if (v.paused && tap) tap.hidden = false; }, 1200); }
      }, 2500);
    });
  });

  /* Review strip: clone the list once so the marquee loops endlessly */
  safe(function () {
    $$('[data-rev-clone]').forEach(function (track) {
      if (track.dataset.cloned) return;
      var kids = Array.prototype.slice.call(track.children);
      if (!kids.length) return;
      kids.forEach(function (k) {
        var c = k.cloneNode(true);
        c.setAttribute('aria-hidden', 'true');
        c.removeAttribute('id');
        var im = c.querySelector('img'); if (im) im.loading = 'lazy';
        track.appendChild(c);
      });
      track.dataset.cloned = '1';
    });
  });
})();
